<template>
  <table class="table-main">
    <tr>
      <td colspan="2" style="padding: 20px 0 0 30px">
        <h3 v-if="user" style="font-weight: 400">{{ $t('dashboard.welcome') }} {{userName}}</h3>
        <h1 style="color: rgba(0, 0, 0, 0.87);font-weight: 300"><b>DTouch</b> {{ $t('dashboard.webs') }}</h1>
      </td>
    </tr>
    <tr>
      <td class="enterprises">
        <v-container grid-list-md>
          <!-- <v-text-field
            :disabled="loadingEnterprises"
            :loading="loadingEnterprises"
            v-model="searchEnterprise"
            append-icon="mdi-magnify"
            :label="$t('common.search')"
            hideDetails
            outlined
            block
            autofocus
            @input="onSearchEnerprise"
            style="margin-bottom:15px;"
            @click:append="onSearchEnerprise"
          /> -->
          <v-text-field
            :disabled="loadingEnterprises"
            :loading="loadingEnterprises"
            v-model="searchEnterprise"
            append-icon="mdi-magnify"
            :label="$t('common.search')"
            hideDetails
            outlined
            block
            autofocus
            style="margin-bottom:15px;"
            @click:append="onSearchEnerprise"
            v-on:keyup="handleEnter"
          />
          <enterprises-menu
            :data="enterprises"
            :onChangeEnterprise="handleChangeEnterprise"
            :onRefreshEnterprise="getEnterprise"
            :user="user"
          />    
          <v-layout wrap v-if="1===2">
            <v-flex
              xs12
              v-for="(item, index) in enterprises"
              :key="`enterprise${index}`"
              style="margin-bottom: 10px"
            >
              <v-card
                class="mx-auto"
                :color="item.BGColor"
                :elevation="item.ID === enterpriseID ? 5 : 0"
                :style="{ 'opacity': item.ID === enterpriseID ? '1' : '0.8' }"
                dark
                max-width="400"
              >
              <v-layout wrap>
                <v-flex xs9 style="padding:20px 0 20px 20px">
                  <!-- <v-icon
                    large
                    left
                    style="font-size:30px;"
                  >
                    mdi-cellphone-text
                  </v-icon> -->
                  <span class="title" style="font-size:22px !important;font-weight: 300">{{item.Name}}</span>
                </v-flex>
                <v-flex xs3 style="padding:20px 15px 20px 0;text-align: right">
                  <v-btn class="mx-2" fab dark small :color="item.BGColorSecundary.substring(0,7).concat('33')"
                    :elevation="0"
                    @click="handleChangeEnterprise(item, true)"
                  >
                    <v-icon :color="item.BGColorSecundary">mdi-cellphone-cog</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-divider />
              <v-layout wrap v-if="item.LMD">
                <v-flex xs9 style="padding:10px 0 10px 25px">
                  <h5 style="font-weight:400;">{{$t('dashboard.lastModification')}} :</h5>
                  <h5 style="font-weight:300;">{{getDate(item.LMD)}}</h5>                  
                </v-flex>
                <v-flex xs3 style="padding:10px 15px 10px 0;text-align: right">
                  <v-btn class="mx-2" fab dark small :color="item.BGColorSecundary.substring(0,7).concat('33')"
                    :elevation="0"
                    @click="handleChangeEnterprise(item, false)"
                  >
                    <v-icon :color="item.BGColorSecundary">mdi-chart-timeline-variant</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-divider />
                <!-- <v-divider 
                  style="margin-top:10px;margin-bottom:10px"
                />
                <h5 style="font-weight:300;padding-left: 20px">{{$t('dashboard.lastModification')}} :</h5>
                <h5 style="font-weight:300;padding-left: 20px">{{getDate(item.LMD)}}</h5> -->
                <!-- <v-divider 
                  style="margin-top:10px;"
                /> -->
                <h5 style="font-weight:400;padding-top: 10px;padding-left: 20px">{{$t('dashboard.content')}} :</h5>
                <v-card-actions
                  style="padding:0px !important;"
                >
                  <v-list-item class="grow">
                    <v-row
                      align="center"
                      style="padding: 10px 15px 15px 15px;"
                    >
                      <v-tooltip
                        bottom
                        v-for="(permission, indexPermission) in JSON.parse(item.Permission).filter(x=> x > 0)"
                        :key="`permission${index}_${indexPermission}`"
                      >
                        <template v-slot:activator="{ on }">
                          <div style="width:31px;height:30px">
                            <v-icon
                              class="mr-1"
                              style="font-size: 25px;opacity:0.4;"
                              v-on="on"
                            >
                              {{getPermission(permission)}}
                            </v-icon>
                            <!-- {{getPermissionName(permission)}} -->
                          </div>
                        </template>
                        <span>{{ getPermissionName(permission) }}</span>
                      </v-tooltip>
                      <!-- <v-icon
                        class="mr-1"
                        v-for="(permission, indexPermission) in JSON.parse(item.Permission)"
                        :key="`permission${index}_${indexPermission}`"
                        style="font-size: 15px;"
                      >
                        {{getPermission(permission)}}
                      </v-icon> -->
                    </v-row>
                  </v-list-item>
                </v-card-actions>
              </v-card>
              <!-- <v-btn
                dark
                block
                :color="item.BGColor"
                @click="handleChangeEnterprise(item)"
              >
                <span :style="{'color': item.Color}">{{ item.Name }}</span>
              </v-btn> -->
            </v-flex>
          </v-layout>
        </v-container>
      </td>
      <td>
        <stats
          v-if="user && user.Permission && user.Permission.indexOf(2) >= 0 && enterpriseID"
          :locale="locale"
          :enterpriseID="enterpriseID"
        />
        <logs
          v-if="user && user.Permission && user.Permission.indexOf(1) >= 0 && enterpriseID"
          :locale="locale"
          :enterpriseID="enterpriseID"
        />
      </td>
    </tr>
  </table>
  <!-- <v-container grid-list-md text-center>
    <v-layout wrap>
      <v-flex
        xs12 sm6 md4
        v-for="(item, index) in enterprises"
        :key="`enterprise${index}`"
      >
        <v-btn
          dark
          block
          color="red darken-1"
          @click="handleChangeEnterprise(item)"
        >
          {{ item.Name }}
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container> -->
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import tmp from './tmp'
  import Logs from './Logs'
  import Stats from './stats/Index'
  import EnterprisesMenu from './EnterprisesMenu'
  import api from '@/services/api'
  import utils from '@/services/utils'
  import constants from '@/constants'
  export default {
    components: {
      tmp,
      Logs,
      Stats,
      EnterprisesMenu
    },
    data: () => ({
      loadingEnterprises: false,
      enterprises: [],
      user: null,
      searchEnterprise: null
    }),
    computed: {
      ...mapState('app',['locale', 'enterpriseID']),
      userName () {
        return this.$store.state.app.userName
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor ? this.$store.state.app.enterpriseColor : 'dtouch'
      }
    },
    created () {
      this.onSearchEnerprise = _.debounce(() => {
        this.handleSearchEnterprise(this.search)
      }, 500)
    },
    mounted () {
      this.getEnterprise()
      this.handleGetUser()
    },
    methods: {
      getEnterprise (filter = '') {            
        this.loadingEnterprises = true            
        api.getAll(`users/${utils.getUserID()}/auth-enterprises/${this.enterpriseID ? this.enterpriseID : utils.getEnterpiseID()}`, true, 1, this.$store.state.app.isAdmin && filter === '' ? 5 : 100000, filter).then(response => {
          this.enterprises = response ? response.data : []
          // console.log(this.enterpriseID, this.enterprises)
          this.sortMenu()
          this.loadingEnterprises = false
        })
        // this.loadingEnterprises = true
        // api.getAll(`users/${utils.getUserID()}/enterprises`, true, 1, this.$store.state.app.isAdmin ? 5 : 100000, filter).then(response => {
        //   const aux = response ? response.data : []

        //   // forzado para que si eres administrador y la empresa seleccionada no esta en los 10 primero siga apareciendo
        //   if (this.$store.state.app.isAdmin && this.enterpriseID && this.enterpriseID.length > 0 && aux.filter(x => x.ID === this.enterpriseID).length <= 0) {
        //     api.getItem(`enterprises`, true, this.enterpriseID).then(response => {
        //       aux.push(response)
        //       this.enterprises = aux
        //       this.sortMenu()
        //       this.loadingEnterprises = false
        //     })
        //   } else {
        //     this.enterprises = aux
        //     this.sortMenu()
        //     this.loadingEnterprises = false
        //   }
        // })
      },
      handleEnter (e) {
        if (e.keyCode === 13) this.handleSearchEnterprise()
      },
      handleSearchEnterprise () {
        this.getEnterprise(this.searchEnterprise)
      },
      handleGetUser () {
        if (this.userID !== 'new') {
          api.getItem('users', true, utils.getUserID()).then(response => {
            this.user = {
              Name: response.Name,
              Email: response.Email,
              Role: response.Role,
              Enterprises: response.Enterprises,
              EnterpriseDefault: response.EnterpriseDefault,
              Permission: response.Permission
            }
          })
        } else {
          this.user = null
        }
      },
      handleChangeEnterprise (enterprise, goToMenus) {
        utils.setActiveEnterprise(this, enterprise)
        this.sortMenu()
        if (goToMenus) this.$router.push('/menus')
      },
      sortMenu () {
        // const aux = []
        // aux.push(...this.enterprises.filter(x => x.ID === this.enterpriseID))
        // aux.push(...this.enterprises.filter(x => x.ID !== this.enterpriseID))
        // this.enterprises = aux
      },
      getPermission (id) {
        const aux = constants.menuType.filter(x => x.id === id)
        return aux && aux.length > 0 ? aux[0].icon : ''
      },
      getPermissionName (id) {
        const aux = constants.menuType.filter(x => x.id === id)
        return aux && aux.length > 0 ? this.$t(`menuType.${aux[0].name}`) : ''
      },
      getDate (value) {
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' }
        if(value) return new Date(value).toLocaleDateString(this.locale, options)
        return ''
      }
    }
  }
</script>

<style lang="postcss" scoped>
  .table-main {
    width: 100%;
  }
  .table-main td {
    vertical-align: top;
  }
  .table-main.body {
    width: auto;
  }
  .enterprises {
    width: 400px;
    padding: 0 5px 0px 20px;
  }
</style>

